var data = {
	v: "5.5.2",
	nm: "Icon-Rigtigt",
	ddd: 0,
	assets: [
	],
	w: 300,
	h: 300,
	ip: 0,
	op: 270,
	fr: 100,
	fonts: {
		list: [
		]
	},
	layers: [
		{
			ty: 4,
			st: 0,
			ip: 0,
			op: 270,
			ks: {
				a: {
					a: 0,
					k: [
						59.499945,
						42.125
					]
				},
				p: {
					a: 0,
					k: [
						149.999999,
						150
					]
				},
				s: {
					a: 1,
					k: [
						{
							t: 0,
							s: [
								150,
								150
							],
							i: {
								x: 0.58,
								y: 1
							},
							o: {
								x: 0.42,
								y: 0
							}
						},
						{
							t: 20,
							s: [
								244.0456,
								244.0455
							],
							i: {
								x: 0.58,
								y: 1
							},
							o: {
								x: 0.42,
								y: 0
							}
						},
						{
							t: 40,
							s: [
								211.3456,
								211.3455
							],
							i: {
								x: 0.58,
								y: 1
							},
							o: {
								x: 0.42,
								y: 0
							}
						},
						{
							t: 60,
							s: [
								229.9269,
								229.9268
							],
							i: {
								x: 0.58,
								y: 1
							},
							o: {
								x: 0,
								y: 0
							}
						},
						{
							t: 80,
							s: [
								211.3456,
								211.3455
							],
							i: {
								x: 0.565,
								y: 1
							},
							o: {
								x: 0.39,
								y: 0.575
							}
						},
						{
							t: 270,
							s: [
								211.3456,
								211.3455
							],
							i: {
								x: 1,
								y: 1
							},
							o: {
								x: 0,
								y: 0
							}
						}
					]
				},
				r: {
					a: 0,
					k: -0.000001
				},
				o: {
					a: 1,
					k: [
						{
							t: 0,
							s: [
								100
							],
							i: {
								x: 1,
								y: 1
							},
							o: {
								x: 0,
								y: 0
							}
						},
						{
							t: 20,
							s: [
								100
							],
							i: {
								x: 1,
								y: 1
							},
							o: {
								x: 0,
								y: 0
							}
						},
						{
							t: 60,
							s: [
								100
							],
							i: {
								x: 1,
								y: 1
							},
							o: {
								x: 0,
								y: 0
							}
						},
						{
							t: 270,
							s: [
								100
							],
							i: {
								x: 1,
								y: 1
							},
							o: {
								x: 0,
								y: 0
							}
						}
					]
				}
			},
			shapes: [
				{
					ty: "gr",
					it: [
						{
							ty: "gr",
							it: [
								{
									ty: "sh",
									ks: {
										a: 0,
										k: {
											v: [
												[
													87,
													9.5
												],
												[
													87,
													9.50008
												],
												[
													86.7349,
													9.88093
												],
												[
													85.3452,
													10.7311
												],
												[
													79.4631,
													12.4072
												],
												[
													59.5,
													14
												],
												[
													39.5369,
													12.4072
												],
												[
													33.6548,
													10.7311
												],
												[
													32.2651,
													9.88093
												],
												[
													32,
													9.50008
												],
												[
													32,
													9.5
												],
												[
													32,
													9.49992
												],
												[
													32.2651,
													9.11907
												],
												[
													33.6548,
													8.26893
												],
												[
													39.5369,
													6.5928
												],
												[
													59.5,
													5
												],
												[
													79.4631,
													6.5928
												],
												[
													85.3452,
													8.26893
												],
												[
													86.7349,
													9.11907
												],
												[
													87,
													9.49992
												],
												[
													87,
													9.5
												]
											],
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0.2659,
													-0.25078
												],
												[
													0.6716,
													-0.3064
												],
												[
													2.5473,
													-0.4916
												],
												[
													7.8264,
													0
												],
												[
													5.0782,
													0.98
												],
												[
													1.337,
													0.61
												],
												[
													0.2678,
													0.25257
												],
												[
													0,
													0.0043
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-0.2659,
													0.25078
												],
												[
													-0.6716,
													0.30641
												],
												[
													-2.5473,
													0.49158
												],
												[
													-7.8264,
													0
												],
												[
													-5.0782,
													-0.97999
												],
												[
													-1.337,
													-0.61005
												],
												[
													-0.2678,
													-0.25255
												],
												[
													0,
													-0.0043
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0.0043
												],
												[
													-0.2678,
													0.25257
												],
												[
													-1.337,
													0.61
												],
												[
													-5.0782,
													0.98
												],
												[
													-7.8264,
													0
												],
												[
													-2.5473,
													-0.4916
												],
												[
													-0.6716,
													-0.3064
												],
												[
													-0.2659,
													-0.25078
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													-0.0043
												],
												[
													0.2678,
													-0.25255
												],
												[
													1.337,
													-0.61005
												],
												[
													5.0782,
													-0.97999
												],
												[
													7.8264,
													0
												],
												[
													2.5473,
													0.49158
												],
												[
													0.6716,
													0.30641
												],
												[
													0.2659,
													0.25078
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											c: true
										}
									}
								},
								{
									ty: "st",
									o: {
										a: 0,
										k: 100
									},
									w: {
										a: 0,
										k: 2
									},
									c: {
										a: 0,
										k: [
											1,
											1,
											1
										]
									},
									lc: 1,
									lj: 1,
									ml: 4,
									d: [
										{
											n: "o",
											nm: "offset",
											v: {
												a: 0,
												k: 0
											}
										}
									]
								},
								{
									ty: "tr",
									o: {
										a: 0,
										k: 100
									},
									a: {
										a: 0,
										k: [
											59.5,
											9.5
										]
									},
									p: {
										a: 0,
										k: [
											59.5,
											9.5
										]
									}
								}
							]
						},
						{
							ty: "gr",
							it: [
								{
									ty: "gr",
									it: [
										{
											ty: "sh",
											ks: {
												a: 0,
												k: {
													v: [
														[
															78.5,
															70.908
														],
														[
															82.3218,
															74.6875
														],
														[
															89.0625,
															66.5625
														]
													],
													i: [
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													o: [
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													c: false
												}
											}
										},
										{
											ty: "st",
											o: {
												a: 0,
												k: 100
											},
											w: {
												a: 0,
												k: 2
											},
											c: {
												a: 0,
												k: [
													1,
													1,
													1
												]
											},
											ml: 4,
											d: [
												{
													n: "o",
													nm: "offset",
													v: {
														a: 0,
														k: 0
													}
												}
											]
										},
										{
											ty: "tr",
											o: {
												a: 0,
												k: 100
											},
											a: {
												a: 0,
												k: [
													83.78125,
													70.625
												]
											},
											p: {
												a: 0,
												k: [
													83.78125,
													70.625
												]
											}
										}
									]
								},
								{
									ty: "gr",
									it: [
										{
											ty: "el",
											p: {
												a: 0,
												k: [
													0,
													0
												]
											},
											s: {
												a: 0,
												k: [
													22.5,
													22.5
												]
											}
										},
										{
											ty: "fl",
											o: {
												a: 0,
												k: 100
											},
											c: {
												a: 0,
												k: [
													0.34902,
													0.627451,
													0
												]
											}
										},
										{
											ty: "tr",
											o: {
												a: 0,
												k: 100
											},
											p: {
												a: 0,
												k: [
													84,
													70
												]
											}
										}
									]
								},
								{
									ty: "tr",
									o: {
										a: 0,
										k: 100
									},
									a: {
										a: 0,
										k: [
											84,
											70
										]
									},
									p: {
										a: 0,
										k: [
											84,
											70
										]
									}
								}
							]
						},
						{
							ty: "gr",
							it: [
								{
									ty: "gr",
									it: [
										{
											ty: "gr",
											it: [
												{
													ty: "el",
													p: {
														a: 0,
														k: [
															0,
															0
														]
													},
													s: {
														a: 0,
														k: [
															3,
															6
														]
													}
												},
												{
													ty: "fl",
													o: {
														a: 0,
														k: 100
													},
													c: {
														a: 0,
														k: [
															0.129412,
															0.137255,
															0.184314
														]
													}
												},
												{
													ty: "tr",
													o: {
														a: 0,
														k: 100
													},
													p: {
														a: 0,
														k: [
															69.5,
															35
														]
													}
												}
											]
										},
										{
											ty: "gr",
											it: [
												{
													ty: "el",
													p: {
														a: 0,
														k: [
															0,
															0
														]
													},
													s: {
														a: 0,
														k: [
															9,
															12
														]
													}
												},
												{
													ty: "fl",
													o: {
														a: 0,
														k: 100
													},
													c: {
														a: 0,
														k: [
															1,
															1,
															1
														]
													}
												},
												{
													ty: "tr",
													o: {
														a: 0,
														k: 100
													},
													p: {
														a: 0,
														k: [
															69.5,
															35
														]
													}
												}
											]
										},
										{
											ty: "tr",
											o: {
												a: 0,
												k: 100
											},
											a: {
												a: 0,
												k: [
													69.5,
													35
												]
											},
											p: {
												a: 0,
												k: [
													69.5,
													35.317923
												]
											}
										}
									]
								},
								{
									ty: "gr",
									it: [
										{
											ty: "gr",
											it: [
												{
													ty: "el",
													p: {
														a: 0,
														k: [
															0,
															0
														]
													},
													s: {
														a: 0,
														k: [
															3,
															6
														]
													}
												},
												{
													ty: "fl",
													o: {
														a: 0,
														k: 100
													},
													c: {
														a: 0,
														k: [
															0.129412,
															0.137255,
															0.184314
														]
													}
												},
												{
													ty: "tr",
													o: {
														a: 0,
														k: 100
													},
													p: {
														a: 0,
														k: [
															49.5,
															35
														]
													}
												}
											]
										},
										{
											ty: "gr",
											it: [
												{
													ty: "el",
													p: {
														a: 0,
														k: [
															0,
															0
														]
													},
													s: {
														a: 0,
														k: [
															9,
															12
														]
													}
												},
												{
													ty: "fl",
													o: {
														a: 0,
														k: 100
													},
													c: {
														a: 0,
														k: [
															1,
															1,
															1
														]
													}
												},
												{
													ty: "tr",
													o: {
														a: 0,
														k: 100
													},
													p: {
														a: 0,
														k: [
															49.5,
															35
														]
													}
												}
											]
										},
										{
											ty: "tr",
											o: {
												a: 0,
												k: 100
											},
											a: {
												a: 0,
												k: [
													49.5,
													35
												]
											},
											p: {
												a: 0,
												k: [
													49.5,
													35.317923
												]
											}
										}
									]
								},
								{
									ty: "tr",
									o: {
										a: 0,
										k: 100
									},
									a: {
										a: 0,
										k: [
											59.5,
											35.317924
										]
									},
									p: {
										a: 0,
										k: [
											59.5,
											35.317924
										]
									},
									s: {
										a: 1,
										k: [
											{
												t: 0,
												s: [
													100,
													100
												],
												i: {
													x: 1,
													y: 1
												},
												o: {
													x: 0,
													y: 0
												}
											},
											{
												t: 150,
												s: [
													100,
													100
												],
												i: {
													x: 1,
													y: 1
												},
												o: {
													x: 0,
													y: 0
												}
											},
											{
												t: 160,
												s: [
													100,
													0
												],
												i: {
													x: 1,
													y: 1
												},
												o: {
													x: 0,
													y: 0
												}
											},
											{
												t: 170,
												s: [
													100,
													100
												],
												i: {
													x: 1,
													y: 1
												},
												o: {
													x: 0,
													y: 0
												}
											},
											{
												t: 180,
												s: [
													100,
													100
												],
												i: {
													x: 1,
													y: 1
												},
												o: {
													x: 0,
													y: 0
												}
											},
											{
												t: 190,
												s: [
													100,
													0
												],
												i: {
													x: 1,
													y: 1
												},
												o: {
													x: 0,
													y: 0
												}
											},
											{
												t: 200,
												s: [
													100,
													100
												],
												i: {
													x: 1,
													y: 1
												},
												o: {
													x: 0,
													y: 0
												}
											},
											{
												t: 270,
												s: [
													100,
													100
												],
												i: {
													x: 1,
													y: 1
												},
												o: {
													x: 0,
													y: 0
												}
											}
										]
									}
								}
							]
						},
						{
							ty: "gr",
							it: [
								{
									ty: "sh",
									ks: {
										a: 0,
										k: {
											v: [
												[
													47.3066,
													50.2048
												],
												[
													70.4092,
													50.205
												]
											],
											i: [
												[
													0,
													0
												],
												[
													0.6418,
													17.9688
												]
											],
											o: [
												[
													0.0001,
													17.9684
												],
												[
													0,
													0
												]
											],
											c: false
										}
									}
								},
								{
									ty: "st",
									o: {
										a: 0,
										k: 100
									},
									w: {
										a: 0,
										k: 2
									},
									c: {
										a: 0,
										k: [
											0,
											0,
											0
										]
									},
									lj: 1,
									ml: 4,
									d: [
										{
											n: "o",
											nm: "offset",
											v: {
												a: 0,
												k: 0
											}
										}
									]
								},
								{
									ty: "tr",
									o: {
										a: 0,
										k: 100
									},
									a: {
										a: 0,
										k: [
											58.86429,
											56.943075
										]
									},
									p: {
										a: 0,
										k: [
											58.86429,
											56.943075
										]
									}
								}
							]
						},
						{
							ty: "gr",
							it: [
								{
									ty: "el",
									p: {
										a: 0,
										k: [
											0,
											0
										]
									},
									s: {
										a: 0,
										k: [
											69,
											68
										]
									}
								},
								{
									ty: "gf",
									o: {
										a: 0,
										k: 100
									},
									s: {
										a: 0,
										k: [
											-11.3115,
											-32.8852
										]
									},
									e: {
										a: 0,
										k: [
											13.499,
											32.5706
										]
									},
									g: {
										p: 2,
										k: {
											a: 0,
											k: [
												0,
												0.709804,
												1,
												0.34902,
												1,
												0.356863,
												0.631373,
												0.015686
											]
										}
									},
									t: 1
								},
								{
									ty: "tr",
									o: {
										a: 0,
										k: 100
									},
									p: {
										a: 0,
										k: [
											59.5,
											44
										]
									}
								}
							]
						},
						{
							ty: "gr",
							it: [
								{
									ty: "sh",
									ks: {
										a: 0,
										k: {
											v: [
												[
													81.2134,
													48.2721
												],
												[
													104.423,
													51.9282
												],
												[
													100.422,
													47.3694
												],
												[
													107.745,
													45.8347
												],
												[
													112.387,
													38.9288
												],
												[
													102.903,
													37.8004
												],
												[
													116.749,
													24.124
												],
												[
													108.065,
													26.5162
												],
												[
													113.507,
													3
												],
												[
													100.622,
													24.124
												],
												[
													81.2134,
													48.2721
												]
											],
											i: [
												[
													0,
													0
												],
												[
													-13.6855,
													8.4857
												],
												[
													0.36,
													0.8124
												],
												[
													-4.122,
													2.5728
												],
												[
													0.4,
													0.7222
												],
												[
													1.881,
													3.8817
												],
												[
													-0.24,
													3.1595
												],
												[
													1.161,
													2.302
												],
												[
													6.883,
													2.2117
												],
												[
													15.046,
													-9.3885
												],
												[
													-4.602,
													-11.1939
												]
											],
											o: [
												[
													2.281,
													5.597
												],
												[
													-2.481,
													-1.4444
												],
												[
													1.08,
													0.3159
												],
												[
													4.122,
													-2.5728
												],
												[
													-1.361,
													0.8576
												],
												[
													9.804,
													-0.0451
												],
												[
													-4.402,
													3.7915
												],
												[
													14.927,
													-2.302
												],
												[
													0.761,
													1.53465
												],
												[
													-15.0868,
													9.3884
												],
												[
													0,
													0
												]
											],
											c: true
										}
									}
								},
								{
									ty: "fl",
									o: {
										a: 0,
										k: 100
									},
									c: {
										a: 0,
										k: [
											1,
											1,
											1
										]
									}
								},
								{
									ty: "tr",
									o: {
										a: 0,
										k: 100
									},
									a: {
										a: 0,
										k: [
											80.022644,
											29.500016
										]
									},
									p: {
										a: 0,
										k: [
											80.022644,
											29.500016
										]
									},
									s: {
										a: 1,
										k: [
											{
												t: 90,
												s: [
													100,
													100
												],
												i: {
													x: 1,
													y: 1
												},
												o: {
													x: 0,
													y: 0
												}
											},
											{
												t: 110.00000000000001,
												s: [
													30,
													123
												],
												i: {
													x: 0.58,
													y: 1
												},
												o: {
													x: 0.42,
													y: 0
												}
											},
											{
												t: 170,
												s: [
													100,
													100
												],
												i: {
													x: 1,
													y: 1
												},
												o: {
													x: 0,
													y: 0
												}
											}
										]
									}
								}
							]
						},
						{
							ty: "gr",
							it: [
								{
									ty: "sh",
									ks: {
										a: 0,
										k: {
											v: [
												[
													37.7866,
													48.2721
												],
												[
													14.5765,
													51.9282
												],
												[
													18.5783,
													47.3694
												],
												[
													11.2551,
													45.8347
												],
												[
													6.61305,
													38.9288
												],
												[
													16.0972,
													37.8004
												],
												[
													2.25114,
													24.124
												],
												[
													10.9349,
													26.5162
												],
												[
													5.49255,
													3
												],
												[
													18.3782,
													24.124
												],
												[
													37.7866,
													48.2721
												]
											],
											i: [
												[
													0,
													0
												],
												[
													13.686,
													8.4857
												],
												[
													-0.3602,
													0.8124
												],
												[
													4.1218,
													2.5728
												],
												[
													-0.40017,
													0.7222
												],
												[
													-1.8808,
													3.8817
												],
												[
													0.2401,
													3.1595
												],
												[
													-1.16048,
													2.302
												],
												[
													-6.883,
													2.2117
												],
												[
													-15.04658,
													-9.3885
												],
												[
													4.602,
													-11.1939
												]
											],
											o: [
												[
													-2.281,
													5.597
												],
												[
													2.4811,
													-1.4444
												],
												[
													-1.0805,
													0.3159
												],
												[
													-4.12183,
													-2.5728
												],
												[
													1.36059,
													0.8576
												],
												[
													-9.8043,
													-0.0451
												],
												[
													4.40192,
													3.7915
												],
												[
													-14.92648,
													-2.302
												],
												[
													-0.76033,
													1.53465
												],
												[
													15.0866,
													9.3884
												],
												[
													0,
													0
												]
											],
											c: true
										}
									}
								},
								{
									ty: "fl",
									o: {
										a: 0,
										k: 100
									},
									c: {
										a: 0,
										k: [
											1,
											1,
											1
										]
									}
								},
								{
									ty: "tr",
									o: {
										a: 0,
										k: 100
									},
									a: {
										a: 0,
										k: [
											38.977356,
											29.5001
										]
									},
									p: {
										a: 0,
										k: [
											38.977356,
											29.500016
										]
									},
									s: {
										a: 1,
										k: [
											{
												t: 90,
												s: [
													100,
													100
												],
												i: {
													x: 1,
													y: 1
												},
												o: {
													x: 0,
													y: 0
												}
											},
											{
												t: 110.00000000000001,
												s: [
													30,
													123
												],
												i: {
													x: 0.58,
													y: 1
												},
												o: {
													x: 0.42,
													y: 0
												}
											},
											{
												t: 170,
												s: [
													100,
													100
												],
												i: {
													x: 1,
													y: 1
												},
												o: {
													x: 0,
													y: 0
												}
											}
										]
									}
								}
							]
						},
						{
							ty: "tr",
							o: {
								a: 0,
								k: 100
							}
						}
					]
				}
			]
		}
	]
};

export { data as default };
//# sourceMappingURL=smiley.correct.json.js.map
